var map = {
	".": 417,
	"./": 417,
	"./index": 417,
	"./index.js": 417,
	"./resources/attach.png": 763,
	"./resources/attachaudio.png": 765,
	"./resources/attachfile.png": 766,
	"./resources/attachimage.png": 767,
	"./resources/attachvideo.png": 764,
	"./resources/close.png": 772,
	"./resources/createpoll.png": 770,
	"./resources/heart.png": 1901,
	"./resources/insertemoji.png": 768,
	"./resources/insertsticker.png": 771,
	"./resources/launchcollaborativedocument.png": 773,
	"./resources/launchcollaborativewhiteboard.png": 774,
	"./resources/sendmessage.png": 769,
	"./style": 133,
	"./style.js": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1900;